<template>
 <div :class="windowClass">
    <v-row no-gutters class="pa-2">
        <v-col cols="12">
          <v-card>
             <v-toolbar >
                   
                  <span style="width: 270px;" class="ml-4">
                       <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="300px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="from_date +' - '+to_date"
                            label="Date range"
                            prepend-icon="mdi-calendar"
                              dense
                              solo
                              hide-details
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="from_date" no-title scrollable class="mr-1">  </v-date-picker>
                         <v-date-picker v-model="to_date" no-title scrollable @input="queryReports(),menu = false">  </v-date-picker>
                      </v-menu>
                  </span>
                   <span style="width: 290px;" class="ml-2">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            solo
                            dense
                            hide-details
                        ></v-text-field>
                        </span>
                        <v-spacer/>
                        <v-btn small text color="success"   @click="$router.push('/checker/new').catch(err => {})"> Go To Checker <v-icon right >mdi-format-list-checks</v-icon></v-btn>
                        
          </v-toolbar>

          
                    <v-data-table
                    class="va-table mt-2"
                    dense
                    :headers="headers"
                    :search="search"
                    disable-sort
                    :items="items"
                    >
                      <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                           <td>
                            {{item.salesman}}
                            </td>
                            <td><router-link :to="'/delivery-view/'+item.delivery_id">{{item.dr_number}}</router-link></td>
                            <td>{{item.outbound_date | moment($date_format)}} </td>
                            <td>{{item.inbound_date | moment($date_format)}} </td>
                            <td :class="STATUS_TEXT(item.status)">{{item.status}} </td>
                            <td class="text-right">{{$money(item.inbound_amount)}}</td>
                            <td class="text-right">{{$money(item.verified_amount)}}</td>
                            <td class="text-right">{{$money($IsNum(item.inbound_amount) - $IsNum(item.verified_amount) )}}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>
      <!-- <va-sales-form :show="form" @DialogEvent="fEvent"/>
        <va-confirm :show="confirm" cancelbtn="No" okbtn="Void" text="Would you like to void this sales?" @DialogEvent="cEvent"/> -->
</div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
      menu: false,
      form:false,
      confirm: false,
        search:'',
        from_date:'',
        to_date: '',
        date_range:"",
        dr_items:{},
        items:[],
        per_type:'Overall',
          headers: [
          { text: 'Salesman', value: 'salesman' },
          { text: 'D.R.', value: 'dr_number' },
          { text: 'Outbound', value: 'outbound_date' },
          { text: 'Inbound', value: 'inbound_date' },
           { text: 'Status', value: 'status'},
          { text: 'Inbound ', align:'right', value: 'inbound_amount' },
          { text: 'Verified ', align:'right', value: 'verified_amount'},
           { text: 'Settlement Amount ', align:'right'},
        ],
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.SET_MENUS()
          this.setLoggedIn(true) 
         this.initRange()
          this.queryReports()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      TOTAL_AMOUNT(){
         var total =  this.sales.reduce((res, item)=>res += this.$IsNum(item.amount),0)
        return total
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn', 'setOverlayLoading']),
      initRange(){
        var current_date = this.$moment()
         var startdate = current_date.subtract(30, "days")
          this.from_date =  this.$moment(startdate).format("YYYY-MM-DD")
          this.to_date =  this.$moment().format("YYYY-MM-DD")
      },
      queryReports(){
        this.items=[]
        this.setOverlayLoading(true)
          this.$http.post("delivery/reports", {from_date:this.from_date, to_date: this.to_date}).then(response => {
                response.data.items !=null?this.items = response.data.items:this.items=[]
                setTimeout(()=>{this.setOverlayLoading(false)}, 1000)
               }).catch(e => {
                console.log(e.data)
            })
      },
      
    },
  }
</script>